class PagesRealisation{

	constructor() {

		let arrayRealisation = document.querySelector('.realisation-last-list');

		if( !arrayRealisation )
			return;

		let items = arrayRealisation.querySelectorAll('.item');

		ScrollTrigger.create({
			trigger: arrayRealisation,
			start: "top 80%",
			end: 99999,
			onEnter: () => {
				arrayRealisation.classList.add("appeared");
			}
		});

		items.forEach( (item, index) => {

			const splitTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 80%",
					end: "bottom 0%",
					onEnter: () => {
						item.classList.add("appeared");
					}
				}
			});

			splitTimeline.to(item.querySelectorAll('.inner'), {
				duration: 1.5,
				y: 0,
				ease: "power4",
				stagger: 0.15
			});

		});

		this.initMap();

	}

	initMap(){

		// let mapRealisation = document.querySelector('.realisation-map');
		// let markers = mapRealisation.querySelectorAll('.marker');
		// let map = mapMaker.createDynamicMap(mapRealisation);
		//
		// markers.forEach( (marker) => {
		// 	mapMaker.createMarker( marker, map);
		// });

	}

}